import { DayLabel, Text } from '@shared/components'
import { Button, Col, Flex, Row, Space } from 'antd'

import { Sms } from 'iconsax-react'
import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { ActivityLogAvatar } from './ActivityLogAvatar'
import { ActivityLogProps } from './types'
import { useGetTranslatedDescription } from './useGetTranslatedDescription'

export const ActivityLogChat = ({ log }: ActivityLogProps) => {
  const { t } = useTranslation()
  const translatedDescription = useGetTranslatedDescription({ log })

  const [showMore, setShowMore] = useState(false)

  const onToggleDescription = () => setShowMore((prevState) => !prevState)

  return (
    <Row justify="space-between" gutter={[16, 16]} align="middle">
      <Col xs={24} xl={12} xxl={12}>
        <Text isEllipsis>
          {showMore && log?.full_description
            ? log?.full_description
            : translatedDescription}
        </Text>
      </Col>

      <Col xs={24} xl={12} xxl={12}>
        <Flex gap={8} wrap justify="end" align="center">
          <ActivityLogAvatar
            user={log?.created_by}
            label={t('task.created_by')}
          />

          <DayLabel date={log.created_at} />

          <Space.Compact>
            <Button
              size="small"
              onClick={onToggleDescription}
              icon={<Sms size={16} />}
            />
          </Space.Compact>
        </Flex>
      </Col>
    </Row>
  )
}
